import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { StaffProfileDataService } from 'src/pms/services/staffprofiles.data.service/staffprofiles.data.service';
import { formatPmsDate } from 'src/pms/utils/pms-date-format.util';
import { ErrorComponent } from 'src/shared/components/design/error/error.component';
import { HorizontalPillsComponent } from 'src/shared/components/design/horizontalpills/horizontalpills.component';
import {
  HorizontalPillsConfig,
  HorizontalPillsConfigItem,
  HorizontalPillsConfigItemType,
} from 'src/shared/components/design/horizontalpills/horizontalpills.interface';
import { LoaderComponent } from 'src/shared/components/design/loader-copy/loader.component';
import { StackedListComponent } from 'src/shared/components/design/stackedlist/stackedlist.component';
import {
  StackedListConfig,
  StackedListItem,
  StackedListItemType,
} from 'src/shared/components/design/stackedlist/stackedlist.interface';
import { TitleComponent } from 'src/shared/components/design/title/title.component';
import { bookinginternal } from 'src/shared/services/client/client';
import { IsClientErrorMessagePipe } from 'src/shared/services/client/client.error.pipe';
import { AppointmentsDataService } from '../../services/appointments.data.service/appointments.data.service';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  imports: [
    TitleComponent,
    AsyncPipe,
    HorizontalPillsComponent,
    StackedListComponent,
    LoaderComponent,
    ErrorComponent,
    IsClientErrorMessagePipe,
  ],
})
export class AppointmentsComponent implements OnInit {
  private router = inject(Router);
  private staffProfileDataService = inject(StaffProfileDataService);
  private appointmentsDataService = inject(AppointmentsDataService);
  private destroyRef = inject(DestroyRef);

  activePillId: string = 'future';
  appointments$!: Observable<bookinginternal.ListAppointmentsV2Response>;
  config$!: Observable<StackedListConfig>;

  ngOnInit(): void {
    this.load();
  }

  getPillsConfig(): HorizontalPillsConfig {
    let config: HorizontalPillsConfig = {
      items: [
        {
          id: 'future',
          active: this.activePillId == 'future',
          type: HorizontalPillsConfigItemType.Callback,
          title: 'Upcoming',
          data: null,
        },
        {
          id: 'past',
          active: this.activePillId == 'past',
          type: HorizontalPillsConfigItemType.Callback,
          title: 'Past',
          data: null,
        },
      ],
    };
    return config;
  }

  pillClicked(pill: HorizontalPillsConfigItem) {
    this.activePillId = pill.id;
    if (pill.id == 'future') {
      this.load();
    } else if (pill.id == 'past') {
      this.load(true);
    }
  }

  load(desc: boolean = false) {
    // TODO - required refactor
    this.staffProfileDataService
      .GetMyStaffProfile()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        const params: bookinginternal.ListAppointmentsV2Request = {
          RequestedItemsPerPage: 50,
          RequestedPageNumber: 1,
          BusinessDocID: '',
          EndDate: '',
          StartDate: '',
          Status: ['Booked'],
          ServiceDocID: '',
          OrderBy: desc ? 'desc' : 'asc',
          PetDocID: '',
          ShiftDocID: '',
          StaffProfileDocID: response.id,
          // TODO - set this from central service
          Timezone: 'Europe/London',
          UserDocID: '',
          Open: false,
          Waiting: false,
          ListAppointmentWithoutStaffProfiles: false,
          ExcludeAppointmentsInConsultationStates: [],
        };
        this.appointments$ = this.appointmentsDataService.ListAppointments(params).pipe(
          catchError((err) => {
            return of(err);
          })
        );
        this.config$ = this.appointments$.pipe(map((data) => this.getConfig(data)));
      });
  }

  book() {
    this.router.navigate(['/book']);
  }

  getConfig(appointments: bookinginternal.ListAppointmentsV2Response): StackedListConfig {
    let config: StackedListConfig = {
      items: [],
    };
    for (let appointment of appointments.appointments) {
      var item: StackedListItem = {
        id: `/appointments/${appointment.doc_id}`,
        type: StackedListItemType.Path,
        title: formatPmsDate(appointment.start.local, 'dateTime'),
        description: appointment.status,
        image: '',
        badges: [],
      };
      if (appointment.is_open) {
        item.badges?.push({
          name: 'Open',
          color: 'yellow',
        });
      }
      if (appointment.is_waiting) {
        item.badges?.push({
          name: 'Waiting',
          color: 'green',
        });
      }
      config.items.push(item);
    }
    return config;
  }
}
